import { render } from "./RoleIndex.vue?vue&type=template&id=49ea8d10&scoped=true"
import script from "./RoleIndex.vue?vue&type=script&lang=js"
export * from "./RoleIndex.vue?vue&type=script&lang=js"

import "./RoleIndex.vue?vue&type=style&index=0&id=49ea8d10&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ea8d10"]])

export default __exports__